import Iframe from 'react-iframe';
import Svg from 'react-inlinesvg';
import { useDispatch, useSelector } from 'react-redux';
import closeBtn from '../../assets/images/icon_images/closeBtn.svg';
import { currentVideoSelector, handleOpenVideoModal } from '../../entities/ComponentsSlice';
import Portal from '../../shared/portal/Portal';
import style from './VideoModal.module.scss';

const VideoModal = () => {
  const dispatch = useDispatch();
  const currentVideo = useSelector(currentVideoSelector);

  return (
    <Portal>
      <div className={style.modal}>
        <div className={style.video}>
          <Iframe
            url={currentVideo}
            display='block'
            position='relative'
            frameBorder={0}
            allowfullscreen={true}
            allow='autoplay; encrypted-media; picture-in-picture; screen-wake-lock;'
            title='Video player'
            autoplay={1}
          />
        </div>
        <button className={style.closeBtn} onClick={() => dispatch(handleOpenVideoModal(false))}>
          <Svg src={closeBtn} className={style.svg} />
        </button>
      </div>
    </Portal>
  );
};

export default VideoModal;
